export const rawCiap = [
  { nm: null, nome: 'ABORTO ESPONTÂNEO', codigo: 'W82', id_grupo: 'ABORTO' },
  { nm: null, nome: 'ABORTO PROVOCADO', codigo: 'W83', id_grupo: 'ABORTO' },
  {
    nm: null,
    nome: 'DIABETES INSULINO-DEPENDENTE',
    codigo: 'T89',
    id_grupo: 'DIABETES',
  },
  {
    nm: null,
    nome: 'DIABETES NÃO INSULINO-DEPENDENTE',
    codigo: 'T90',
    id_grupo: 'DIABETES',
  },
  { nm: null, nome: 'GRAVIDEZ', codigo: 'W78', id_grupo: 'GRAVIDEZ' },
  {
    nm: null,
    nome: 'GRAVIDEZ NÃO DESEJADA',
    codigo: 'W79',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'TOXEMIA GRAVÍDICA/ DHEG',
    codigo: 'W81',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ DE ALTO RISCO',
    codigo: 'W84',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'DIABETES GESTACIONAL',
    codigo: 'W85',
    id_grupo: 'GRAVIDEZ',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO SEM COMPLICAÇÕES',
    codigo: 'K86',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'HIPERTENSÃO COM COMPLICAÇÕES',
    codigo: 'K87',
    id_grupo: 'HIPERTENSAO',
  },
  {
    nm: null,
    nome: 'ESCLARECIMENTO/DISCUSSÃO DO MOTIVO DA CONSULTA',
    codigo: '48',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTROS PROCEDIMENTOS PREVENTIVOS',
    codigo: '49',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PSICOLÓGICOS, OUTROS',
    codigo: 'P29',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PÓS-PARTO',
    codigo: 'W18',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS DA MAMA/LACTAÇÃO',
    codigo: 'W19',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'SEPSIS/INFECÇÃO PUERPERAL',
    codigo: 'W70',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO SEM COMPLICAÇÕES DE NASCIDO VIVO',
    codigo: 'W90',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO SEM COMPLICAÇÕES DE NATIMORTO',
    codigo: 'W91',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO COM COMPLICAÇÕES DE NASCIDO VIVO',
    codigo: 'W92',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'PARTO COM COMPLICAÇÕES DE NATIMORTO',
    codigo: 'W93',
    id_grupo: 'PARTO',
  },
  { nm: null, nome: 'MASTITE PUERPERAL', codigo: 'W94', id_grupo: 'PARTO' },
  {
    nm: null,
    nome: 'OUTROS PROBLEMAS DA MAMA DURANTE GRAVIDEZ/PUERPÉRIO',
    codigo: 'W95',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'OUTRAS COMPLICAÇÕES DO PUERPÉRIO',
    codigo: 'W96',
    id_grupo: 'PARTO',
  },
  {
    nm: null,
    nome: 'MEDO DE VIH/ HIV/SIDA/ AIDS',
    codigo: 'B25',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDO DE ESTAR GRÁVIDA',
    codigo: 'W02',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO PÓS-COITAL',
    codigo: 'W10',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO ORAL',
    codigo: 'W11',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO INTRA-UTERINA/ DISPOSITIVO INTRAUTERINO/ DIU',
    codigo: 'W12',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ESTERILIZAÇÃO',
    codigo: 'W13',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'CONTRACEPÇÃO/OUTROS',
    codigo: 'W14',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'INFERTILIDADE/SUBFERTILDADE',
    codigo: 'W15',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'GRAVIDEZ NÃO DESEJADA',
    codigo: 'W79',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'ABORTO ESPONTÂNEO',
    codigo: 'W82',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DOR GENITAL',
    codigo: 'X01',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DORES MENSTRUAIS',
    codigo: 'X02',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DORES INTERMENSTRUAIS',
    codigo: 'X03',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'RELAÇÃO SEXUAL DOLOROSA NA MULHER',
    codigo: 'X04',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO ESCASSA/AUSENTE',
    codigo: 'X05',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO EXCESSIVA',
    codigo: 'X06',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MENSTRUAÇÃO IRREGULAR/FREQUENTE',
    codigo: 'X07',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA INTERMENSTRUAL',
    codigo: 'X08',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS PRÉ-MENSTRUAIS',
    codigo: 'X09',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'DESEJO DE ALTERAR A DATA MENSTRUAÇÃO',
    codigo: 'X10',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SINAIS/SINTOMAS DA MENOPAUSA/ CLIMATÉRIO',
    codigo: 'X11',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA PÓS-MENOPAUSA',
    codigo: 'X12',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'HEMORRAGIA PÓS-COITAL',
    codigo: 'X13',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDO DE DOENÇA DE TRANSMISSÃO SEXUAL',
    codigo: 'X23',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'MEDO DE DISFUNÇÃO SEXUAL',
    codigo: 'X24',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'LESÃO TRAUMÁTICA GENITAL FEMININA',
    codigo: 'X82',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'SÍNDROME DA TENSÃO PRÉ-MENSTRUAL',
    codigo: 'X89',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
  {
    nm: null,
    nome: 'PLANEJAMENTO FAMILIAR, OUTROS',
    codigo: 'Y14',
    id_grupo: 'SAUDE_SEXUAL_REPRODUTIVA',
  },
]
